export default __webpack_public_path__ + "static/media/bcchLogo.63154d4e.svg";